import Model from "../Model";

class TypeClientsTop extends Model{

    buildUrl ({ param }) {
        return ['/filters/getclienttypefilter/', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new TypeClientsTop;